export default __webpack_public_path__ + "static/media/job_offer14_s.14c31480.jpg";